import { BrandSection } from "@/components/auth/BrandSection";
import { CountryChrome } from "@/domains/shared/components/CountryChrome/CountryChrome";
import { LanguageChrome } from "@/domains/shared/components/LanguageChrome/LanguageChrome";
import { Outlet } from "react-router";

export default function LoginLayout() {
    return (
        <div className="grid min-h-screen min-h-dvh w-full bg-background lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)]">
            <aside className="relative hidden min-h-screen min-h-dvh overflow-hidden border-r border-border bg-muted/40 lg:block">
                <BrandSection />
            </aside>
            <section className="flex min-h-screen min-h-dvh flex-col bg-background">
                <div className="flex items-center justify-end gap-2 p-4 lg:p-6">
                    <CountryChrome />
                    <LanguageChrome />
                </div>
                <div className="flex flex-1 items-center justify-center px-5 pb-10 sm:px-8 lg:pb-16">
                    <div className="w-full max-w-sm sm:max-w-md">
                        <Outlet />
                    </div>
                </div>
            </section>
        </div>
    );
}
